var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #233c6a;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48.2,
    cy: 49.3,
    r: 38.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.2,90.7c-5.6,0-11-1.1-16.1-3.3-4.9-2.1-9.4-5.1-13.2-8.9-3.8-3.8-6.8-8.2-8.9-13.2-2.2-5.1-3.3-10.5-3.3-16.1s1.1-11,3.3-16.1c2.1-4.9,5.1-9.4,8.9-13.2s8.2-6.8,13.2-8.9c5.1-2.2,10.5-3.3,16.1-3.3s11,1.1,16.1,3.3c4.9,2.1,9.4,5.1,13.2,8.9,3.8,3.8,6.8,8.2,8.9,13.2,2.2,5.1,3.3,10.5,3.3,16.1s-1.1,11-3.3,16.1c-2.1,4.9-5.1,9.4-8.9,13.2-3.8,3.8-8.2,6.8-13.2,8.9-5.1,2.2-10.5,3.3-16.1,3.3ZM48.2,13.9c-19.5,0-35.4,15.9-35.4,35.4s15.9,35.4,35.4,35.4,35.4-15.9,35.4-35.4S67.7,13.9,48.2,13.9Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.6,32.1l-25.5,25.5c-.2.2-.4.2-.6,0l-12.9-12.9c-.2-.2-.4-.2-.6,0l-6.2,6.2c-.2.2-.2.4,0,.6l19.8,19.8c.2.2.4.2.6,0l6.4-6.4h0c0,0,25.8-25.9,25.8-25.9.2-.2.2-.4,0-.6l-6.4-6.4c-.2-.2-.4-.2-.6,0h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.5a9fa3829eb3ef872c1d27dff42f348f.svg";
export { ForwardRef as ReactComponent };